import { render, staticRenderFns } from "./AppSwitch.vue?vue&type=template&id=17eb1192&"
import script from "./AppSwitch.vue?vue&type=script&lang=js&"
export * from "./AppSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AppSwitch.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports